import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: "cxone-checkbox-cell",
    templateUrl: "./cxone-checkbox-cell.component.html",
    styleUrl: "./cxone-checkbox-cell.component.scss",
})
export class CxoneCheckboxCellComponent implements ICellRendererAngularComp {
    public checked: boolean = false;
    public params: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        return true;
    }

    onCheckboxChange(event: any): void {
        const isChecked = event.checked;
        this.params.node.setSelected(isChecked);
    }
}

